import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import './BusinessProfile.css';

const BusinessProfile = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) observer.disconnect();
    };
  }, []);

  return (
    <section
      className={`business-profile-section ${isVisible ? 'is-visible' : ''}`}
      ref={sectionRef}
    >
      <div className="business-profile-container">
        <div className="business-profile-content">
          <div className="business-profile-text-wrapper">
            <h2 className="business-subtitle">Explore Our Services</h2>
            <h1 className="business-title">
              Business <br />
              <span className="highlight-text">Profile</span>
            </h1>
            <p className="business-description">
              Discover our comprehensive range of agri-business solutions designed to empower farmers and optimize production. We bring innovation to the field.
            </p>

            <Link to="/arg-business" className="cta-button-wrapper">
              <button className="premium-btn">
                <span>Learn More</span>
                <span className="icon-wrapper">
                  <ArrowRight size={20} />
                </span>
              </button>
            </Link>
          </div>
        </div>

        <div className="business-profile-visual">
          <div className="image-card-wrapper">
            <div className="image-card">
              <img
                src="https://res.cloudinary.com/drevfgyks/image/upload/v1734041691/Response-Website_y6hkj4.jpg"
                alt="Agri-Business Services"
                className="business-image"
              />
              <div className="glass-overlay"></div>
            </div>
            <div className="decorative-circle circle-1"></div>
            <div className="decorative-circle circle-2"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BusinessProfile;
